// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.mjs";

function Make($star) {
  var t_encode = Decco.stringToJson;
  var t_decode = Decco.stringFromJson;
  var toString = function (id) {
    return id;
  };
  var fromString = function (id) {
    return id;
  };
  var codec = [
    t_encode,
    t_decode
  ];
  return {
          toString: toString,
          fromString: fromString,
          toJson: t_encode,
          fromJson: t_decode,
          codec: codec,
          t_encode: t_encode,
          t_decode: t_decode
        };
}

export {
  Make ,
}
/* No side effect */
